import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
export function ClosingSection() {
  return <section className="relative bg-gray-900 text-white py-24 md:py-32 px-4 overflow-hidden" data-id="element-45">
      {/* Background glow effects */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-46"></div>

      <div className="container mx-auto max-w-3xl text-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-48">
          <Sparkles className="w-8 h-8 text-amber-400 mx-auto mb-6 animate-pulse" data-id="element-49" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-50">
          Reiki no te está buscando
          <br className="hidden md:block" data-id="element-51" />{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-white to-amber-200" data-id="element-52">
            por casualidad
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="relative inline-block mb-12" data-id="element-53">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-300 rounded-lg blur opacity-20" data-id="element-54"></div>
          <p className="relative text-xl md:text-2xl text-gray-200 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-55">
            "No necesitás más información. <br data-id="element-56" />
            Necesitás un sistema que te acompañe y te sostenga."
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-57">
          <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center gap-3 px-12 py-6 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_40px_rgba(245,158,11,0.4)] hover:shadow-[0_0_60px_rgba(245,158,11,0.6)] transition-all transform hover:scale-105" data-id="element-58">
            <span data-id="element-59">Accedé ahora al MegaPack Reiki</span>
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-60" />

            {/* Button glow effect */}
            <div className="absolute inset-0 rounded-full bg-white/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-61"></div>
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-lg text-amber-200/80 font-serif italic" data-id="element-62">
          ✨ La sanación ya está en vos. Solo necesitás activarla.
        </motion.p>
      </div>
    </section>;
}